import React from 'react'
import Button from './Button'
import Input from './Input'
import DatePicker from './DatePicker'
import PasswordInput from './PasswordInput'

const Controls ={
    Button,
    Input,
    DatePicker,
    PasswordInput,
}


export default Controls
